import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import AIChatbots from './pages/AIChatbots';
import BusinessAutomation from './pages/BusinessAutomation';
import DocumentAI from './pages/DocumentAI';
import About from './pages/About';
import Contact from './pages/Contact';
import CustomAI from './pages/CustomAI';
import GenerativeAI from './pages/GenerativeAI';
import AIEngineering from './pages/AIEngineering';
import AutonomousAgents from './pages/AutonomousAgents';
import AIWorkflowAutomation from './pages/AIWorkflowAutomation';

import WebDevelopment from './pages/WebDevelopment';
import MobileDevelopment from './pages/MobileDevelopment';
import UIDesign from './pages/UIDesign';
import AIAutomationSolutions from './pages/AIAutomationSolutions';
import SaaSDevelopment from './pages/SaaSDevelopment';
import CustomSoftware from './pages/CustomSoftware';
import CloudDevOps from './pages/CloudDevOps';
import ITSupport from './pages/ITSupport';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/ai-chatbots" element={<AIChatbots />} />
          <Route path="/services/business-automation" element={<BusinessAutomation />} />
          <Route path="/services/document-ai" element={<DocumentAI />} />
          <Route path="/services/custom-ai-projects" element={<CustomAI />} />

          <Route path="/generative-ai" element={<GenerativeAI />} />
          <Route path="/ai-engineering" element={<AIEngineering />} />
          <Route path="/autonomous-agents" element={<AutonomousAgents />} />
          <Route path="/ai-workflow-automation" element={<AIWorkflowAutomation />} />

          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/mobile-development" element={<MobileDevelopment />} />
          <Route path="/services/ui-ux-design" element={<UIDesign />} />
          <Route path="/services/ai-automation" element={<AIAutomationSolutions />} />
          <Route path="/services/saas-development" element={<SaaSDevelopment />} />
          <Route path="/services/custom-software" element={<CustomSoftware />} />
          <Route path="/services/cloud-devops" element={<CloudDevOps />} />
          <Route path="/services/it-support" element={<ITSupport />} />

          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
